exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#ComparePeriod {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  height: 100%;\n}\n\n#ComparePeriod > div {\n  display: -ms-flexbox;\n  display: flex;\n  /* justify-content: space-between; */\n  /* flex-direction: column; */\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n#ComparePeriod .PeriodDatesPickerContainer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  height: 70px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/stats/containers/PeriodDatesPickerContainer.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/stats/containers/PeriodDatesPickerContainer.css
// module chunks = 0